import { Label } from 'cpool-components/general/Label';
import { useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import type { SchemaManualOfferForm } from '~/features/leadDetails/schemas/manualOfferForm.schema';
import { cn } from '~/utils/cnTailwind';

type Props = {
    labelClassName: string;
};

export const OfferFileInput: React.FC<Props> = ({ labelClassName }) => {
    const { t } = useTranslation();
    const { control, setValue } = useFormContext<SchemaManualOfferForm>();
    const file = useWatch({ control, name: 'file' });

    return (
        // min-w-0 lets flex children actually shrink below their content's width, so the filename
        // truncates instead of the row (and the whole modal) growing to fit it
        <div className="flex min-w-0 items-start gap-2.5">
            <Label className={labelClassName} htmlFor="offer-file">
                {t('OFFER_MANAGEMENT.MANUAL_OFFER.UPLOAD_OFFER')}
            </Label>
            <label
                className={cn(
                    'flex h-8 min-w-0 flex-1 cursor-pointer items-center rounded border border-solid border-grey-outline-light',
                    'bg-white px-2.5 text-14 text-midnight hover:bg-surface-light',
                )}
                htmlFor="offer-file"
            >
                <span className={cn('min-w-0 flex-1 truncate', !file && 'text-grey')}>
                    {file instanceof File ? file.name : t('OFFER_MANAGEMENT.MANUAL_OFFER.SELECT_FILE')}
                </span>
                <input
                    accept="application/pdf"
                    className="hidden"
                    id="offer-file"
                    onChange={(event) => {
                        const selectedFile = event.target.files?.[0];
                        if (selectedFile) setValue('file', selectedFile, { shouldDirty: true });
                    }}
                    type="file"
                />
            </label>
        </div>
    );
};
